/**
 * LiveFlight Selection Module
 * Handles selected flight offer and baggage options
 */

/**
 * Selection state properties
 */
export const state = {
  // Selected flight
  flight_offer: {},
  flight_offer_has_upsell: false,

  // Baggage
  bags: {},
  flexible_bags: {},
  has_flexible_bags_last_selection: false,

  // Populated by provider.book_held() on detail submit for providers
  // with the ancillariesAsStep capability. /ancillaries reads this to
  // fetch against the held bookingId; checkout uses it to gate payment.
  held_booking: { id: "", expires_at: "" },

  // Hold-expiry countdown read by the resume sidebar's
  // checkout-timer. `_start` is the epoch-ms
  // moment book_held wrote the values; `_amount` is the remaining
  // seconds derived from the server's `expiresAt`.
  checkout_timer_start: 0,
  checkout_timer_amount: 0,
};

/**
 * Custom mutations for selection state
 */
export const mutations = {
  // Atomic mutation: selects a flight offer and resets all dependent state in a single commit.
  // Prevents 5 separate subscribe handler calls (localStorage writes).
  select_flight_offer(state, flight_offer) {
    state.bags = {};
    state.flexible_bags = {};
    state.traveler_details = [];
    state.contact_details = {};
    state.held_booking = { id: "", expires_at: "" };
    state.flight_offer = flight_offer;
    state.checkout_timer_start = 0;
    state.checkout_timer_amount = 0;
  },
};

/**
 * Keys to persist in local storage
 */
export const localStorageKeys = [
  "flight_offer",
  "bags",
  "flexible_bags",
  "has_flexible_bags_last_selection",
  "held_booking",
  "checkout_timer_start",
  "checkout_timer_amount",
];
